import React from 'react';
import ImageComponent from 'atoms/Image/index';
import { ButtonType, ContainedButton } from 'atoms/Buttons';
import { createAccount } from 'common/utilities/LoginUtils';

export const SignMeUPBanner = ({ contentData = {}, customTag = 'h2' }) => {
  const {
    headline = '',
    subHeadline = '',
    desktopSrc = '',
    buttonText = '',
    subHeadline2 = '',
    stripesIcon,
  } = contentData;

  return (
    <>
      {
        <div id='kfc-signMeUpBanner' className='signMeUpBanner-container' data-testid='signMeUpBanner'>
          <div className='signMeUpBanner-stripes-icon'>
            <ImageComponent srcFile={stripesIcon} className='signMeUpBanner-stripes-img' alt='' />
          </div>
          <div className='headline-container'>
            <p className='signMeUpBanner-heading creat-account'>{headline}</p>
          </div>
          {customTag === 'h2' ? (
            <h2 className='signMeUpBanner-heading subHeadline'>{subHeadline}</h2>
          ) : (
            <h3 className='signMeUpBanner-heading subHeadline'>{subHeadline}</h3>
          )}
          <div className='signMeUpBanner-heading-container'>
            <p className='signMeUpBanner-heading subHeadline2'>{subHeadline2}</p>
          </div>
          {buttonText && (
            <ContainedButton
              variant={ButtonType.secondary}
              data-testid='signMeUp-submit'
              aria-label={buttonText}
              onClickHandler={createAccount}
            >
              {buttonText}
            </ContainedButton>
          )}
          <div className='signMeUpBanner-kfc-box'>
            <ImageComponent srcFile={desktopSrc} className='signMeUpBanner-img' alt='' />
          </div>
        </div>
      }
    </>
  );
};
export default SignMeUPBanner;
